(() => {
  if (customElements.get('ggc-product-gallery')) return;
  class GGCProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-ggc-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-ggc-index]'));
      this.status = this.querySelector('[data-ggc-status]');
      this.dialog = this.querySelector('dialog');
      this.enlarged = this.querySelector('[data-ggc-enlarged]');
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {
        event.preventDefault();
        this.show(index);
      }, options));
      this.querySelector('[data-ggc-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-ggc-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelectorAll('[data-ggc-zoom]').forEach(link => link.addEventListener('click', event => {
        if (Date.now() - (this.lastSwipe || 0) < 400) { event.preventDefault(); return; }
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.zoomTrigger = link;
        this.enlarged.src = link.href;
        this.enlarged.alt = link.querySelector('img').alt;
        this.dialog.showModal();
      }, options));
      this.querySelector('[data-ggc-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.zoomTrigger?.focus(), options);
      this.addEventListener('keydown', event => {
        if (this.dialog.open || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const focusWasOnSlide = event.target.closest('[data-ggc-zoom]');
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          if (focusWasOnSlide) this.slides[this.index].querySelector('a').focus();
        }
      }, options);
      const stage = this.querySelector('.ggc-product-gallery__stage');
      let start;
      stage.addEventListener('touchstart', event => {
        const touch = event.touches[0];
        start = {x: touch.clientX, y: touch.clientY};
      }, {...options, passive: true});
      stage.addEventListener('touchend', event => {
        if (!start) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.lastSwipe = Date.now();
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      }, {...options, passive: true});
      this.setAttribute('data-ready', '');
      this.show(this.index);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        if (i === this.index) slide.querySelector('img').loading = 'eager';
      });
      this.thumbs.forEach((thumb, i) => i === this.index ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
      this.status.replaceChildren(document.createTextNode(this.thumbs[this.index].dataset.ggcLabel + ' '));
      const count = document.createElement('span');
      count.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.status.append(count);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('ggc-product-gallery', GGCProductGallery);
})();
